import React, { useState } from 'react';
import FakeTable from './fakeTable';

import { ThemeProvider } from '@mui/material/styles';
import Slider from "@mui/material/Slider";
import { ToggleButton, ButtonGroup } from 'react-bootstrap';

import { coolingMethods, coolingEnglishToDutch } from '../nameMapping/coolingMethods';
import { houseTypes, housesEnglishToDutch } from '../nameMapping/homeTypes';

// The filter stage component is a table containing the time-series heat data, which it obtains from the main page source through argument passing
export default function FilterStage({metaData, setHeatData, getHeatData, heatData, theme}) {
  const [devices, setDevices] = useState([[],[]]);
  const [deviceIndices, setDeviceIndices] = useState([0,0]);
  const [selectedCoolingMethod, setCoolingMethod] = useState(["",""]);
  const [selectedHouseType, setHouseType] = useState(["",""]);

  const onChangeDataset = function (value, dataSetIdx) {
    const newDataSetIdx = value-1;
    const newDeviceIndex = [...deviceIndices];
    newDeviceIndex[dataSetIdx] = newDataSetIdx;
    setDeviceIndices(newDeviceIndex);
    getHeatData(devices[dataSetIdx][newDataSetIdx], dataSetIdx);
  }

  // Get all the data sets corresponding to the selected criteria after a new behaviour was selected
  function getDatasetsWithSelectedBehaviour(coolingMethod, houseType, dataSetIdx) {
    // Create a list of device ids that recorded the desired data
    const newDevices = [];
    let count = 0;
    for(let i = 0; i < metaData.length; i++) {
      if((metaData[i].cooling_method).includes(coolingEnglishToDutch[coolingMethod])) {
        if(!houseType || metaData[i].type_house.includes(housesEnglishToDutch[houseType])) {
          newDevices.push(metaData[i].device_id);
          count += 1;
        }
      }
      if(count === 15) break;
    }
    const newDeviceArray = [...devices];
    newDeviceArray[dataSetIdx] = newDevices;
    // Obtain the datasets corresponding to the device ids
    getHeatData(newDevices[0], dataSetIdx);
    setDevices(newDeviceArray);
  }

  // Get all the data sets corresponding to the selected criteria after a new house type was selected
  function getDatasetsWithSelectedHouseType(coolingMethod, houseType, dataSetIdx) {
    // Create a list of device ids that recorded the desired data
    const newDevices = [];
    let count = 0;
    for(let i = 0; i < metaData.length; i++) {
      if((metaData[i].type_house).includes(housesEnglishToDutch[houseType])) {
        if(!coolingMethod || metaData[i].cooling_method.includes(coolingEnglishToDutch[coolingMethod])) {
          newDevices.push(metaData[i].device_id);
          count += 1;
        }
      }
      if(count === 15) break;
    }
    const newDeviceArray = [...devices];
    newDeviceArray[dataSetIdx] = newDevices;
    // Obtain the datasets corresponding to the device ids
    getHeatData(newDevices[0], dataSetIdx);
    setDevices(newDeviceArray);
  }

  // Create a component that displays the buttons to select the cooling method
  function getCoolingMethodButtonArray(dataSetIdx) {
    return (
      <div>
        {coolingMethods.map((coolingMethod, idx) => (
          <ToggleButton
            size="sm"
            key={`method-${idx}-${dataSetIdx}`}
            id={`method-${idx}-${dataSetIdx}`}
            type="radio"
            variant= {dataSetIdx > 0 ? "outline-success" : "outline-danger"}
            value={coolingMethod[0]}
            checked={coolingMethod[0] === selectedCoolingMethod[dataSetIdx]}
            onChange={(e) => {
              const newSelectedCoolingMethod = [...selectedCoolingMethod];
              newSelectedCoolingMethod[dataSetIdx] = e.currentTarget.value;
              setCoolingMethod(newSelectedCoolingMethod);
              getDatasetsWithSelectedBehaviour(coolingMethod[0], selectedHouseType[dataSetIdx], dataSetIdx);
              const newDeviceIndices = [...deviceIndices];
              newDeviceIndices[dataSetIdx] = 0;
              setDeviceIndices(newDeviceIndices);
            }}
          >
            {
            <div dangerouslySetInnerHTML={{__html: coolingMethod[1]}} ></div>
            } 
          </ToggleButton>
        ))}
        <ToggleButton
          size="sm"
          key={`deselectCool-${dataSetIdx}`}
          id={`deselectCool-${dataSetIdx}`}
          type="radio"
          variant= {dataSetIdx > 0 ? "outline-success" : "outline-danger"}
          value={""}
          checked={"" === selectedCoolingMethod[dataSetIdx]}
          onChange={(e) => {
            const newSelectedCoolingMethod = [...selectedCoolingMethod];
            newSelectedCoolingMethod[dataSetIdx] = "";
            setCoolingMethod(newSelectedCoolingMethod);
            const newDeviceIndex = [...deviceIndices];
            newDeviceIndex[dataSetIdx] = 0;
            setDeviceIndices(newDeviceIndex);
            const newDevices = [...devices];
            newDevices[dataSetIdx] = [];
            setDevices(newDevices);
            if(selectedHouseType[dataSetIdx] === "") {
              const newHeatData = [...heatData];
              newHeatData[dataSetIdx] = [];
              setHeatData(newHeatData);
            } else {
              getDatasetsWithSelectedHouseType("", selectedHouseType[dataSetIdx], dataSetIdx);
            }
          }}
        >
          <span class="material-symbols-outlined">close</span>
        </ToggleButton>
      </div>
    );
  }

  // Create a component that displays the buttons to select the house type
  function getHouseTypeButtonArray(dataSetIdx) {
    return (
      <div>
        {houseTypes.map((houseType, idx) => (
          <ToggleButton
            size="sm"
            key={`house-${idx}-${dataSetIdx}`}
            id={`house-${idx}-${dataSetIdx}`}
            type="radio"
            variant= {dataSetIdx > 0 ? "outline-success" : "outline-danger"}
            value={houseType[0]}
            checked={houseType[0] === selectedHouseType[dataSetIdx]}
            onChange={(e) => {
              const newSelectedHouseType = [...selectedHouseType];
              newSelectedHouseType[dataSetIdx] = e.currentTarget.value;
              setHouseType(newSelectedHouseType);
              getDatasetsWithSelectedHouseType(selectedCoolingMethod[dataSetIdx], houseType[0], dataSetIdx);
              const newDeviceIndices = [...deviceIndices];
              newDeviceIndices[dataSetIdx] = 0;
              setDeviceIndices(newDeviceIndices);
            }}
          >
            {<div dangerouslySetInnerHTML={{__html: houseType[1]}} ></div>}
          </ToggleButton>
        ))}
        <ToggleButton
          size="sm"
          key={`deselectHouse-${dataSetIdx}`}
          id={`deselectHouse-${dataSetIdx}`}
          type="radio"
          variant= {dataSetIdx > 0 ? "outline-success" : "outline-danger"}
          value={""}
          checked={"" === selectedHouseType[dataSetIdx]}
          onChange={(e) => {
            const newSelectedHouseType = [...selectedHouseType];
            newSelectedHouseType[dataSetIdx] = e.currentTarget.value;
            setHouseType(newSelectedHouseType);
            const newDeviceIndices = [...deviceIndices];
            newDeviceIndices[dataSetIdx] = 0;
            setDeviceIndices(newDeviceIndices);
            const newDevices = [...devices];
            newDevices[dataSetIdx] = [];
            setDevices(newDevices);
            // if(selectedCoolingMethod[dataSetIdx] !== "") {
            //   getDatasetsWithSelectedBehaviour(selectedCoolingMethod[dataSetIdx], e.currentTarget.value, dataSetIdx);
            // } else {
              const newHeatData = [...heatData];
              newHeatData[dataSetIdx] = [];
              setHeatData(newHeatData);
            // }
          }}
        >
          <span class="material-symbols-outlined">close</span>
        </ToggleButton>
      </div>
    );
  }

  // Slider for selecting the data set
  function prevAndNext(dataSetIdx) {
    const sliderColor = dataSetIdx > 0 ? "secondary" : "primary";
    return (
      <div style={{ margin: "0 0em" }}>
        Select dataset
        <ThemeProvider theme={ theme }>
          <Slider
            key={`select-${dataSetIdx}`}
            id={`select-${dataSetIdx}`}
            color={sliderColor}
            defaultValue={1}
            value={deviceIndices[dataSetIdx]+1}
            onChangeCommitted={(e, val) => onChangeDataset(val,dataSetIdx)}
            valueLabelDisplay="auto"
            step={1}
            marks
            min={1}
            max={devices[dataSetIdx].length}
            disabled={devices[dataSetIdx].length <= 0}
          />
        </ThemeProvider>
      </div>
    );    
  }

  return (
    <div style={{ display: "grid", gridTemplateColumns: "2fr 1fr" }}>
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
          <p style={{ margin: "0" }}><nobr>Select cooling method:&nbsp;</nobr></p>
          <ButtonGroup>
            {getCoolingMethodButtonArray(0)}
          </ButtonGroup>
          <ButtonGroup>
            {getCoolingMethodButtonArray(1)}
          </ButtonGroup>
        </div>
        <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", alignItems: "center" }}>
          <p style={{ margin: "0" }}><nobr>Select house type:&nbsp;</nobr></p>
          <ButtonGroup>
            {getHouseTypeButtonArray(0)}
          </ButtonGroup>
          <ButtonGroup>
            {getHouseTypeButtonArray(1)}
          </ButtonGroup>
          <div style={{ width: "0" }}></div>
        </div>
        <div style={{ display: "flex", justifyContent: "center" }}>
            {prevAndNext(0)}
        </div>
        <div style={{ display: "flex", justifyContent: "center" }}>
            {prevAndNext(1)}
        </div>
      </div>
      <FakeTable />
    </div>
  );
}